import { brandApi } from '../lib/axios';

export interface BrandAffiliateTaxInfo {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  taxProfile: {
    id: string;
    taxYear: number;
    formType: 'W9' | 'W8BEN';
    legalName: string;
    businessName?: string | null;
    entityType?: string;
    taxCountry: string;
    taxIdLast4: string;
    address: any;
    status: string;
    createdAt: string;
    updatedAt: string;
  };
  totalPaid: number;
}

export interface ReauthenticatePayload {
  password: string;
}

export interface RevealTaxIdPayload {
  taxProfileId: string;
}

export interface RevealTaxIdResponse {
  taxId: string;
}

export const brandTaxComplianceService = {
  /**
   * Re-authenticate brand user with password
   */
  async reauthenticate(password: string): Promise<{ success: boolean }> {
    const response = await brandApi.post<{ success: boolean }>(
      '/affiliate-tax-profile/brand/reauthenticate',
      { password }
    );
    return response.data;
  },

  /**
   * Get all affiliates with tax info for current year
   */
  async getAffiliatesTaxInfo(year?: number): Promise<BrandAffiliateTaxInfo[]> {
    const response = await brandApi.get<BrandAffiliateTaxInfo[]>(
      '/affiliate-tax-profile/brand/affiliates',
      {
        params: year ? { year } : {},
      }
    );
    return response.data;
  },

  /**
   * Get single affiliate tax info (with access logging)
   */
  async getAffiliateTaxInfo(
    affiliateId: string,
    year?: number
  ): Promise<any> {
    const response = await brandApi.get(
      `/affiliate-tax-profile/brand/affiliates/${affiliateId}`,
      {
        params: year ? { year } : {},
      }
    );
    return response.data;
  },

  /**
   * Reveal full tax ID (with access logging)
   */
  async revealTaxId(
    affiliateId: string,
    taxProfileId: string
  ): Promise<RevealTaxIdResponse> {
    const response = await brandApi.post<RevealTaxIdResponse>(
      `/affiliate-tax-profile/brand/affiliates/${affiliateId}/reveal-tax-id`,
      { taxProfileId }
    );
    return response.data;
  },

  /**
   * Export tax info as CSV
   */
  async exportTaxInfo(
    year?: number,
    affiliateId?: string
  ): Promise<Blob> {
    const response = await brandApi.get('/affiliate-tax-profile/brand/export', {
      params: {
        ...(year && { year }),
        ...(affiliateId && { affiliateId }),
      },
      responseType: 'blob',
    });
    return response.data;
  },
};

